import type { FormEvent } from 'react';
import styled from '@emotion/styled';
import { tokens } from '@hotjar/hotsauce';

const Container = styled.form<{ width: number }>`
  width: ${({ width }) => width}px;
  background: ${tokens.color.ui_background};
  ${tokens.elevation(2)};
  border: 1px solid ${tokens.color.ui_border};
  border-radius: ${tokens.radius.m};
  color: ${tokens.color.text_default};
`;

interface FilterDropdownProps {
  ariaLabel: string;
  customWidth?: number;
  onApply?: () => void;
  isDisabled?: boolean;
  children: React.ReactNode;
}

export function GenericFilterDropdown({
  children,
  customWidth = 280,
  ariaLabel,
  isDisabled,
  onApply,
}: FilterDropdownProps): JSX.Element {
  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (isDisabled !== true) {
      onApply?.();
    }
  };
  return (
    <Container aria-label={ariaLabel} width={customWidth} role="dialog" onSubmit={handleSubmit}>
      {children}
    </Container>
  );
}
